export const escapeTruckNumber = (truckNumber: string) => {
  const cyrillic = 'АВСЕНІКМОРТХ' // here 'A' is U+0410
  const latin = 'ABCEHIKMOPTX' // here 'A' is U+0041

  const map: { [key: string]: string } = {}
  for (let i = 0; i < cyrillic.length; i++) {
    map[cyrillic[i]] = latin[i]
  }

  return truckNumber
    .toUpperCase()
    .replace(/[АВСЕНІКМОРТХ]/g, char => map[char] || char)
    .replace(/[^ABCEHIKMOPTX0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZБГДЖЗЁИЙЛМПУФЦЧШЩЬЫЪЭЮЯ]/g, '')
}

export const formatVesselVisitIdentifier = (
  carrierName?: string | null,
  vesselVisitNumber?: string | null,
): string | undefined => {
  const trimmedCarrierName = carrierName?.trim()
  const trimmedVesselVisitNumber = vesselVisitNumber?.trim()

  if (!trimmedVesselVisitNumber) {
    return trimmedCarrierName
  }

  if (!trimmedCarrierName) {
    return trimmedVesselVisitNumber
  }

  return `${trimmedCarrierName}:${trimmedVesselVisitNumber}`
}
